// Expense  State

import i18n from '@/i18n'

export default {
  expenseList: [],
  expenseInfo: {},
  dateFilter: [
    { text: i18n.t('Accounting Period'), value: 'THIS_ACCOUNTING_PERIOD' },
    { text: i18n.t('Today'), value: 'TODAY' },
    { text: i18n.t('This Month'), value: 'THIS_MONTH' },
    { text: i18n.t('Last Month'), value: 'LAST_MONTH' },
    { text: i18n.t('This Quarter'), value: 'THIS_QUARTER' },
    { text: i18n.t('Last Quarter'), value: 'LAST_QUARTER' },
    { text: i18n.t('This Year'), value: 'THIS_YEAR' },
    { text: i18n.t('Last Year'), value: 'LAST_YEAR' },
    { text: i18n.t('Date Period'), value: 'DATE_PERIOD' }
  ]
}
